var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 30,
   loop: true,
  autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
  navigation: {
        nextEl: ".arrow-righttt",
        prevEl: ".arrow-lefttt",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });


$('.announcement-main').show();    
  
  $('#my-keen-slider').marquee({
   direction: 'left',
    duration: 25000,
    gap: 0,
    delayBeforeStart: 0,
    duplicated: true,
    startVisible: true
});



 










var BSP_swiper = new Swiper(".BSP_swiper", {
      slidesPerView: "auto",  
      spaceBetween: 26,  
      
  navigation: {
        nextEl: ".arrow-right",
        prevEl: ".arrow-left",
      },
      breakpoints: {
        320: {
          // centeredSlides: true,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
          },
        },
        550: {
          spaceBetween: 16,         
        },
        750: {
          spaceBetween: 26,
        },
        1200: {
          spaceBetween: 33,
        },
      },        
    });


 var play_box_Swiper = new Swiper(".play-product", {
      slidesPerView: "auto",
      spaceBetween: 25,
   slidesPerGroup: 1,
   navigation: {
        nextEl: ".play_arrow-right",
        prevEl: ".play_arrow-left",
      },
    breakpoints: {        
        550: {
          spaceBetween: 44,   
          slidesPerGroup: 4,
        },
      },
    });



 var tab_Swiper = new Swiper(".tab_Swiper", {
      slidesPerView: "auto",
      spaceBetween: 38,
      //  navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },  
   
   }
    );

var Collection_link = new Swiper(".Collection-link", {
      slidesPerView: "auto",
      spaceBetween: 0,
       navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },   
  breakpoints: {        
        750: {
          spaceBetween: 38,         
        },
      },
   }
    );


// Code for tab Active And Slide

var index_value=jQuery('.data_active').length;
if(index_value > 0)
{
  var index_value=jQuery('.data_active').attr('data_id');
  Collection_link.slideTo(index_value);
  
}


// End Code for tab Active And Slide





var Tab_swiper = new Swiper(".tab_pro_slider", {
      slidesPerView: "auto",
      spaceBetween: 10, 
  navigation: {
        nextEl: ".arrow-right_teb",
        prevEl: ".arrow-left_teb",
      },  
  breakpoints: {
        750: {
          spaceBetween: 33,         
        },
  }
    });


$(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){




        let page = __st.p;
  let sectionTitle = "curate your hair care"
  let TabTitle = jQuery(this).find('span').text().trim();

  let data = {
    section_name: sectionTitle,
    tab_name: TabTitle,
    pagename: page,
  };

  let eventObj = {
    eventName: "COLLECTION TAB",
    eventData: data,
  };

  //console.log("------//------", eventObj);
     Shopify.analytics.publish('percept_custom_event', eventObj);
        





        
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  //initComparisons();
  
  });









  var mySwiper_fade = new Swiper(".mySwiper_fade", {
      spaceBetween: 30,
      effect: "fade",
    autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      loop:true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });









$(document).ready(function() {
  let isLoading = false;  

   $(window).scroll(function() {
      var check_scroll=jQuery('.js-load-more').attr('data-load');
      if(typeof check_scroll != "undefined" || check_scroll != null)
      {
        if($(window).width()<=800)
        {
          var height_val=5000;
        }else
        {
          var height_val=3500;
        }
        
        
               if ($(window).scrollTop() + $(window).height() >= $(document).height() - parseInt(height_val) && !isLoading) {
                isLoading = true;
                 var __this = $(".js-load-more"),
                  totalPages = parseInt($('[data-all-pages]').val()),
                  currentPage = parseInt($("[data-this-page]").val()),
                  datacollurl = $("[data-coll-url]").val();
                __this.attr("disabled", true);
                __this.find("[load-more-text]").addClass("hide");
                __this.find("[loader]").removeClass("hide");
                
                var nextUrl = $('.next_url').attr('value');
                
                var current_page_new = currentPage + 1;
                var next_coll = currentPage + 2;
                //alert(current_page_new);
                //return false;
                $.ajax({
                  url: nextUrl,
                  type: "GET",
                  dataType: "html",
                  success: function (responseHTML) {
                    
                    $("[data-next-url]").val(datacollurl + "?page=" + next_coll);
                    $("[data-this-page]").val(current_page_new);
                     
                      if(typeof responseHTML != "undefined" || responseHTML != null)
                    {
                    var productsHtml = $(responseHTML).find('.collection_product-grid li'); 
                    
                      $(".collection_product-grid").append(productsHtml);
                    }
                    isLoading=false;
                  },
                  complete: function () {
                    if (current_page_new < totalPages) {
                      __this.attr("disabled", false);
                      __this.find("[load-more-text]").removeClass("hide");
                      __this.find("[loader]").addClass("hide");
                    }
                    if (current_page_new >= totalPages) {
                      __this.find("[load-more-text]").text("Products Finished").removeClass("hide");
                      __this.find("[loader]").addClass("hide");
                      
                    }
                  },
                });
                
              }
        }  
   });

});




$(".js-load-more").on("click", function () {
  jQuery(this).attr('data-load',true);
  var __this = $(this),
    totalPages = parseInt($('[data-all-pages]').val()),
    currentPage = parseInt($("[data-this-page]").val()),
    datacollurl = $("[data-coll-url]").val();
  __this.attr("disabled", true);
  __this.find("[load-more-text]").addClass("hide");
  __this.find("[loader]").removeClass("hide");
  
  var nextUrl = $('.next_url').attr('value');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;
  //alert(current_page_new);
  //return false;
  $.ajax({
    url: nextUrl,
    type: "GET",
    dataType: "html",
    success: function (responseHTML) {
      
      $("[data-next-url]").val(datacollurl + "?page=" + next_coll);
      $("[data-this-page]").val(current_page_new);
       
      var productsHtml = $(responseHTML).find('.collection_product-grid li'); 
      $(".collection_product-grid").append(productsHtml);
    },
    complete: function () {
      if (current_page_new < totalPages) {
        __this.attr("disabled", false);
        __this.find("[load-more-text]").removeClass("hide");
        __this.find("[loader]").addClass("hide");
      }
      if (current_page_new >= totalPages) {
        __this.find("[load-more-text]").text("Products Finished").removeClass("hide");
        __this.find("[loader]").addClass("hide");
        
      }
    },
  });
});









jQuery(document).on("click", ".video_btn", function (e) {
  
  // e.preventDefault();
  let page = __st.p;


  let sectionTitle = "Home Video Banner Slider";
  let Buttontext = "shop bestsellers";

  let data = {
    section_name: sectionTitle,
    button_name: Buttontext,
    pagename: page,
  };

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };
  //console.log("------//------", eventObj);

    Shopify.analytics.publish('percept_custom_event', eventObj);
});





///////////////

jQuery(document).on("click", ".best-sell-main .quick-add__submit", function (e) {
  let page = __st.p;

  let sectionTitle = jQuery(this)
    .closest(".best-sell-main")
    .find(".best-sell-title")
    .text()
    .trim();

  
  let productTitle = jQuery(this)
    .closest(".best_sell_li")
    .find(".sec__card__content h3 a")
    .text()
    .trim();

  
  let productType = jQuery(this)
    .closest(".best_sell_li")
    .find(".card__information.sec__card__information")
    .data("pro-type"); 

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

 // console.log("------//------", eventObj);
    Shopify.analytics.publish('percept_custom_event', eventObj);
});


////////////////



jQuery(document).on("click", ".best-sell-main .bottom_btn a", function (e) {
  

  let page = __st.p;


  let sectionTitle = "the crowd favourites";
  let Buttontext = "explore all";

  let data = {
    section_name: sectionTitle,
    button_name: Buttontext,
    pagename: page,
  };

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };
  
  Shopify.analytics.publish('percept_custom_event', eventObj);
});






/////////////


jQuery(document).on("click", ".collection_tab_main .quick-add__submit", function (e) {
  let page = __st.p;

  let sectionTitle = jQuery(this)
    .closest(".collection_tab_main")
    .find(".collection_tab_main_title")
    .text()
    .trim();

  
  let productTitle = jQuery(this)
    .closest(".badge_on")
    .find(".sec__card__content h3 a")
    .text()
    .trim();

  
  let productType = jQuery(this)
    .closest(".badge_on")
    .find(".card__information.sec__card__information")
    .data("pro-type"); 

let ActiveTabText = jQuery(this)
    .closest(".collection_tab_inner")
    .find(".collec_tab .swiper-slide a.swiper-slide-tab-link.active span")
    .text()
    .trim();

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
    active_tab_text:ActiveTabText,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

 //console.log("------//------", eventObj);
     Shopify.analytics.publish('percept_custom_event', eventObj);
});


jQuery(document).on("click", ".tab_product_main .bottom_btn a", function (e) {
   //e.preventDefault();
  let page = __st.p;


  let sectionTitle = "curate your hair care";
  let Buttontext = "Explore all";

  let ActiveTabText = jQuery(this)
    .closest(".collection_tab_inner")
    .find(".collec_tab .swiper-slide a.swiper-slide-tab-link.active span")
    .text()
    .trim();

  let data = {
    section_name: sectionTitle,
    button_name: Buttontext,
    pagename: page,
    active_tab_text:ActiveTabText,
  };

  

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };
  //console.log("------//------", eventObj);

    Shopify.analytics.publish('percept_custom_event', eventObj);
});



jQuery(document).on("click", ".quiz-left-inner a", function (e) {
   //e.preventDefault();
  let page = __st.p;


  let sectionTitle = "Quiz Section";
  let Buttontext = "take the quiz";

 

  let data = {
    section_name: sectionTitle,
    button_name: Buttontext,
    pagename: page,
   
  };

  

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };
  //console.log("------//------", eventObj);

    Shopify.analytics.publish('percept_custom_event', eventObj);
});




jQuery(document).on("click", ".custom-banner a", function (e) {
   //e.preventDefault();
  let page = __st.p;


  let sectionTitle = "THE MOXIE MAKER - About-us";
  

  let data = {
    section_name: sectionTitle,
    pagename: page,
  };

  

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };
  //console.log("------//------", eventObj);

    Shopify.analytics.publish('percept_custom_event', eventObj);
});





/////////////////


jQuery(document).on("click", ".sample_product .quick-add__submit", function (e) {
  let page = __st.p;

  let sectionTitle = "CLAIM YOUR TWO FREE MINIS!"

  
  let productTitle = jQuery(this)
    .closest(".product-card-wrapper")
    .find(".sec__card__content h3 a")
    .text()
    .trim();

  
  let productType = jQuery(this)
    .closest(".product-card-wrapper")
    .find(".card__information.sec__card__information")
    .data("pro-type"); 

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  //console.log("------//------", eventObj);
    Shopify.analytics.publish('percept_custom_event', eventObj);
});




////////
jQuery(document).on("click", ".CT_cart_product_secend .quick-add__submit", function (e) {
  let page = __st.p;

  let sectionTitle = "COMPLETE YOUR ROUTINE"

  
  let productTitle = jQuery(this)
    .closest(".product-card-wrapper")
    .find(".sec__card__content h3 a")
    .text()
    .trim();

  
  let productType = jQuery(this)
    .closest(".product-card-wrapper")
    .find(".card__information.sec__card__information")
    .data("pro-type"); 

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  //console.log("------//------", eventObj);
    Shopify.analytics.publish('percept_custom_event', eventObj);
});




///////////// Collection page 


jQuery(document).on("click", ".Collection-link li a", function (e) {
   //e.preventDefault();
  let page = __st.p;

  let Collection_switch_button_text = jQuery(this).find("span").text().trim();

  let collectionTitle = jQuery(".ct_collection_main").attr("collection_title") || "";

  let data = {
    Collection_switch_button_text: Collection_switch_button_text,
    pagename: page,
    collection_title: collectionTitle
  };

  let eventObj = {
    eventName: "Collection_switch_button",
    eventData: data,
  };

  //console.log("------//------", eventObj);

   Shopify.analytics.publish('percept_custom_event', eventObj);
});




//////////////

jQuery(document).on("click", ".ct_collection_main .quick-add__submit", function (e) {
  let page = __st.p;
  let collectionTitle = jQuery(".ct_collection_main").attr("collection_title") || "";
  let productTitle = jQuery(this)
    .closest(".grid__item")
    .find(".sec__card__content h3 a")
    .text()
    .trim();

  let productType = jQuery(this)
    .closest(".grid__item")
    .find(".card__information.sec__card__information")
    .data("pro-type"); 

  let data = {
    collection_title: collectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  //console.log("------//------", eventObj);
    Shopify.analytics.publish('percept_custom_event', eventObj);
});




//////////
// jQuery(document).on("click", "#FacetsWrapperDesktop details ul li label", function (e) {
  
//   let page = __st.p;

  
//   let filter_text = jQuery(this).find(".ct_filter_text").text().trim();

 
//   let collectionTitle = jQuery(".ct_collection_main").attr("collection_title") || "";

 
//   let Filter_main_label = jQuery(this)
//     .closest(".ct_filter_main")
//     .find(".ct_filter_label")
//     .text()
//     .trim();

//   let data = {
//     filter_text: filter_text,
//     pagename: page,
//     collection_title: collectionTitle,
//     filter_main_label: Filter_main_label,
//   };

//   let eventObj = {
//     eventName: "Collection_filter",
//     eventData: data,
//   };

//   console.log("------//------", eventObj);
// });




jQuery(document).off("click", ".custom_comp .quick-add__submit").on("click", ".custom_comp .quick-add__submit", function (e) {
  let page = __st.p;

  let sectionTitle = "Upgrade your routine - Product details";

  let productTitle = jQuery(this)
    .closest(".complementary-slide")
    .find(".sec__card__content h3 a")
    .text()
    .trim();

  let productType = jQuery(this)
    .closest(".complementary-slide")
    .find(".card__information.sec__card__information")
    .data("pro-type"); 

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  //console.log("------//------", eventObj);
   Shopify.analytics.publish('percept_custom_event', eventObj);
});

